<template>
  <posting-shell />
</template>

<script>
import PostingShell from "@/components/finance-posting/PostingShell.vue";

/** Knjiženje narudžbi (/ledger-posting, samo admin): ručno knjiženje završenih narudžbi koje noćna provjera još nije proknjižila. */
export default {
  name: "FinancePostingPage",
  components: { PostingShell },
};
</script>
